export default ({ src, className, onClick, display, float }) => (
  <>
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: src }}
      style={{ display, float }}
      onClick={onClick}
    />
  </>
);
